import React from 'react';

const MainTab = () => {
  return (
    <div className="main-tab">
      {/* Simple Title Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Hacienda de Aldama</h1>
        </div>
      </section>
    </div>
  );
};

export default MainTab;
